<template>
  <div class="text-area-block">
    <transition v-on:before-appear="beforeEnter" name="fade" appear>
      <div
        class="editor-holder text-area-content"
        :style="textStyle"
        v-html="$t(html, blockTranslationContext + '.options.data')"
        data-appear="250"
        v-show="showText"
      ></div>
    </transition>
  </div>
</template>
<script>
import TranslationMixin from '@/lib/TranslationMixin';
import Utilities from '@/lib/Utilities';
export default {
  props: {
    config: { type: Object, default: () => {} },
  },
  inject: ['blockTranslationContext'],
  mixins: [TranslationMixin],
  data() {
    return {
      componentKey: null,
      hasSettings: false,
      showText: true,
      content: {},
      html: '',
    };
  },
  methods: {
    beforeEnter: function(el, done) {
      Velocity(
        el,
        { opacity: 0, translateY: "100%", translateZ: 0 },
        { duration: 0 }
      );
      const delay = Number(el.dataset.appear);
      setTimeout(function() {
        Velocity(
          el,
          { opacity: 1, translateY: "0%", translateZ: 0 },
          { complete: done, duration: 500 }
        );
      }, delay);
    },
    mounted() {
      this.animateIn("showText", 1000);
    },
  },
  computed: {
    textStyle() {
      return {
        textAlign: this.content.textAlign,
        color: this.content.textColor,
      };
    },
  },
  created() {
    this.componentKey = Utilities.key();
    this.content = this.config;
    this.html = Utilities.editorToHTML(this.content.data);
  },
};
</script>
<style lang="scss" scoped></style>
